module.exports = __webpack_public_path__ + "static/media/sun.2cffe0e2.svg";